<template>
  <div class="contact">
    <div class="contact__inner">
      <div class="contact__item animation-item animation-item animation-top"
        v-for="(contacItem, index) in contactItems"
        :key="index"
        :class="`animation-item--delay${index}`">
        <div class="contact__icon">
          <img :class="contacItem.icon"
               :src="require(`@/assets/icons/${contacItem.icon}.svg`)"
            :alt="contacItem.header"
          />
        </div>
        <div class="contact__content">
          <h3>{{contacItem.header}}</h3>
          <div class="contact__text" v-html="contacItem.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'contact',
  data: () => ({
    contactItems: [
      {
        icon: 'icon-adress',
        header: 'ADRES',
        text: '<p>Centrum Innowacyjnej Archiwizacji</p>' +
          '<p>Pro-Inwest s.c. A.Dobrowolski, D.Dobrowolska, M.Dobrowolska</p>' +
          '<p>ul. Modelarska 10<br/>40-142 Katowice</p>',
      },
      {
        icon: 'icon-phone',
        header: 'TELEFON',
        text: '<p><a class="contact__anchor" href="tel:32 209 05 32">32 209 05 32</a></p>',
      },
      {
        icon: 'icon-email',
        header: 'EMIAL',
        text: '<p><a class="contact__anchor" href="mailto:archiwum@pro-inwest.org">archiwum@pro-inwest.org</a></p>',
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
  .contact {
    background: #fff;
    padding-top: 30px;
    @media (min-width: 740px) {
      padding-top: 0;
    }
    &__inner {
      @media (min-width: 740px) {
        display: flex;
      }
    }
    &__item {
      text-align: center;
      margin-bottom: 60px;
      @media (min-width: 740px) {
        margin-bottom: 0;
        flex: 1 1 33.333333%;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    &__icon {
      img {
        width: 42px;
        height: 42px;
        margin: 0 auto;
        display: block;
      }
    }
    &__content {
      max-width: 280px;
      margin: 0 auto;

      h3 {
        color: #1976d2;
        font-weight: 500;
        font-size: 16px;
        padding: 30px 0;
      }
      p {
        font-size: 14px;
        padding-bottom: 15px;
        margin-bottom: 0;
        @media (min-width: 550px) {
          padding-bottom: 20px;
          font-size: 16px;
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
    &__anchor {
      color: #000 !important;
      text-decoration: none;
      &:hover {
        color: #0080ff;
      }
    }
  }
</style>
